import Lang from './Lang.js'

export default class RepeaterFields {
    #element

    #rowNumber

    #props

    #refs

    #values

    #errors

    constructor(element) {
        this.#element = element
        this.#values = JSON.parse(element.dataset.values)
        this.#errors = JSON.parse(element.dataset.errors)
        this.#rowNumber = 1

        this.getProps()
        this.#refs = this.getRefs(element)

        this.addBindings()

        this.parseValues()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new RepeaterFields(element))
    }

    getProps() {
        this.#props = JSON.parse(this.#element.dataset.props)
    }

    getRefs(el) {
        let result = {}

        ;[...el.querySelectorAll('[data-ref]')].forEach((ref) => {
            result[ref.dataset.ref] = ref
        })

        return result
    }

    addBindings() {
        this.#refs.addButton.onclick = (e) => {
            e.preventDefault()
            this.addRow(true)
        }
    }

    createFromHTML(html = '') {
        let element = document.createElement(null)
        element.innerHTML = html

        return element.firstElementChild
    }

    renderRow(inputKey = '', inputValue = '', inputKeyFeedback = '', inputValueFeedback = '') {
        return `
            <div class="d-flex w-full gap-4 items-start mb-5 repeatable-field-row">
                <div class="w-1/3">
                    <input
                        data-ref="inputKey"
                        type="text"
                        name="${this.#props.inputName}[${this.#rowNumber}][key]"
                        placeholder="${Lang.get('micro_game.properties.key')}"
                        value="${inputKey}"
                        class="form-control"
                        aria-label="${this.#props.labelText} #${this.#rowNumber}"
                    />
                    <div class="invalid-feedback">${inputKeyFeedback}</div>
                </div>
                <div class="flex-grow-1">
                <textarea
                    data-ref="inputValue"
                    name="${this.#props.inputName}[${this.#rowNumber}][value]"
                    class="form-control"
                    placeholder="${Lang.get('micro_game.properties.value')}"
                    aria-label="${this.#props.labelText} #${this.#rowNumber}"
                    rows="3">${inputValue}</textarea>
                    <div class="invalid-feedback">${inputValueFeedback}</div>
                </div>
                <div class="flex-shrink-0">
                    <button data-ref="removeButton" type="button" class="btn btn-sm mt-1 repeatable-field-remove-button">
                        <i class="bi bi-x-lg text-danger"></i>
                        ${this.#props.removeLabel ?? ''}
                    </button>
                </div>
            </div>
        `
    }

    parseValues() {
        if (Object.keys(this.#values).length > 0) {
            for (const row in this.#values) {
                let keyError = ''
                let valueError = ''

                if (
                    this.#errors.hasOwnProperty(
                        this.#props.inputName + '.' + this.#rowNumber + '.key'
                    )
                ) {
                    keyError = this.#errors['fields.' + this.#rowNumber + '.key'][0]
                }

                if (
                    this.#errors.hasOwnProperty(
                        this.#props.inputName + '.' + this.#rowNumber + '.value'
                    )
                ) {
                    valueError = this.#errors['fields.' + this.#rowNumber + '.value'][0]
                }

                this.addRow(
                    false,
                    this.#values[row].key ?? '',
                    this.#values[row].value ?? '',
                    keyError,
                    valueError
                )
            }

            return
        }

        this.addRow()
    }

    addRow(
        focusInput = false,
        inputKey = '',
        inputValue = '',
        inputKeyFeedback = '',
        inputValueFeedback = ''
    ) {
        let newRow = this.createFromHTML(
            this.renderRow(inputKey, inputValue, inputKeyFeedback, inputValueFeedback)
        )
        const rowRefs = this.getRefs(newRow)

        rowRefs.removeButton.onclick = (e) => {
            e.preventDefault()
            this.removeRow(newRow)
        }

        this.#refs.rowList.appendChild(newRow)

        if (focusInput) {
            rowRefs.inputKey.focus()
        }

        this.#rowNumber += 1
    }

    removeRow(row) {
        if (this.#refs.rowList.children.length <= 1) {
            return
        }

        row.remove()
        this.#element.focus()

        this.#refs.addButton.style.display = ''
    }
}
